import ModalsUtil from '../../../utils/modals';
import {useDispatch, useSelector} from 'react-redux';
import Selector from '../../../selectors/modals/language';
import {setLanguage as setLanguageActive} from '../../../reducers/app/actions';
import ImageUtil from '../../../utils/image';

export default () => {
    const {language} = useSelector(Selector),
          dispatch = useDispatch();

    const setLanguage = language => {
        dispatch(setLanguageActive(language));
        setTimeout(() => ModalsUtil.close(), 200);
    }

    return (
        <div className="modal modal-language animate__zoomIn animate__animated" data-target="language" style={{display: 'none'}}>
            <div className="modal-close" onClick={e => ModalsUtil.close()}></div>
            <div className="language-list">
                <div className={`language ${language === 'us' ? 'active' : ''}`} onClick={e => setLanguage('us')}>
                    <div className="flag">
                        <ImageUtil
                            path="/images/flags/us.png"
                            alt="USA" />
                    </div>
                    <div className="text">ENGLISH</div>
                </div>
                {/* <div className={`language ${language === 'mx' ? 'active' : ''}`} onClick={e => setLanguage('mx')}>
                    <div className="flag">
                        <ImageUtil
                            path="/images/flags/mx.png"
                            alt="Mexican" />
                    </div>
                    <div className="text">MEXICAN</div>
                </div> */}
                {/* <div className={`language ${language === 'ph' ? 'active' : ''}`} onClick={e => setLanguage('ph')}>
                    <div className="flag">
                        <img
                            src={`${window.location.origin}/source/images/flags/ph.png`}
                            alt="philippines" />
                    </div>
                    <div className="text" style={{fontSize: '67px'}}>Philippines</div>
                </div>
                <div className={`language ${language === 'cb' ? 'active' : ''}`} onClick={e => setLanguage('cb')}>
                    <div className="flag">
                        <img
                            src={`${window.location.origin}/source/images/flags/cb.png`}
                            alt="cuba" />
                    </div>
                    <div className="text">Cuba</div>
                </div>
                <div className={`language ${language === 'bz' ? 'active' : ''}`} onClick={e => setLanguage('bz')}>
                    <div className="flag">
                        <img
                            src={`${window.location.origin}/source/images/flags/bz.png`}
                            alt="Brazil" />
                    </div>
                    <div className="text" style={{fontSize: '80px'}}>Brazilian</div>
                </div> */}
            </div>
        </div>
    )
}